module.exports = __webpack_public_path__ + "img/1ad8890.png";